import APIService from '../api.service';

export const All = (params) => {
  return APIService.get(`/v01/adjustments`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
      product_type: params.type,
      start_date: params.startDate,
      end_date: params.endDate,
      category: params.category,
    },
  });
};

export const Create = (body, config) => {
  return APIService.post(`/v01/create-stock-adjustment`, body, config);
}

export const AllProducts = (params) => {
  return APIService.get(`/v01/all-products`, {
    params: {
      product_type: params.type,
      warehouse_id: params.warehouse_id,
    },
  });
};

export const AdjustOutAll = (body) => {
  return APIService.post(`/v01/adjustments/adjust-out-all`, body);
};

const StockAdjustmentService = {
  All,
  Create,
  AllProducts,
  AdjustOutAll,
}

export default StockAdjustmentService;